<label *ngIf="title" [for]="name" class="title">{{title}}</label>
<div role="button"
  class="controls"
  [ngClass]="{
    'open': showMenu,
    'full-width': fullWidth,
    'disabled': disabledState,
    'invalid': isInvalid
  }"
  (click)="setShowMenu(!showMenu)"
  (clickOutside)="setShowMenu(false)">
  <span *ngIf="search.value === '' || !search.value " class="placeholder">{{ placeholder ?? 'Select ' + (title ?? 'value') }}</span>
  <input #searchInput type="text" [id]="name" [name]="name" autocomplete="off" class="input" [formControl]="search">
  <button title="toggle dropdown" class="arrow" [ngClass]="{'open': showMenu}" type="button"></button>
</div>
<lib-alert-message *ngIf="!!error && isInvalid" type="danger">{{error}}</lib-alert-message>
<div *ngIf="showMenu" class="menu">
  <ul>
    <li *ngIf="filteredOptions?.length === 0" class="menu-option">No results found.</li>
    <li *ngFor="let option of filteredOptions; let i = index"
      [attr.data-trackingid]="trackingIdPrefix + '_autocomplete'"
      [ngClass]="{
        'divided': i === dividerIndex && !filtering,
        'selected': option.label === search.value
      }"
      class="menu-option"
      (click)="selectOption(option)"
    >
      <button
        [attr.data-trackingid]="trackingIdPrefix + '_autocomplete'"
        [innerHTML]="option.label" type="button"
      ></button>
    </li>
  </ul>
</div>
